import React from "react";
import { Button } from "@chakra-ui/react";

const Navbar = () => {
  return <div>Navbar</div>;
};

export default Navbar;
